import * as React from 'react';
import { PowerPoleQuestions } from './models/JobInterfaces';
import { GenericList } from './models/JobSharedInterfaces';

interface NewJobPricelistPowerPoleQuestionsProps {
    isReadOnly: boolean;
    isUnderground: boolean;
    powerPoleQuestions: PowerPoleQuestions;
    gateCode: string;
    yesNoOptions: GenericList[];
    superSafeSupplierOptions: GenericList[];
    powerPoleLocationOptions: GenericList[];
    powerPoleDistanceOptions: GenericList[];
    errors: { [key: string]: string };
    updatePowerPoleQuestions(powerPoleQuestions: PowerPoleQuestions, calculatePrice: boolean): void;
    updateGateCode(gateCode: string): void;
}

const NewJobPricelistPowerPoleQuestionsData = (props: NewJobPricelistPowerPoleQuestionsProps) => {
    const handleQuestionChange = (e: any) => {
        //when updating the newjobpricelist to hooks, change this to pass in name and value, so can use prevState for updating
        var questions = props.powerPoleQuestions;
        let questionItem: any = {};
        questionItem = questions;
        questionItem[e.target.name] = e.target.value * 1;

        if (e.target.name === "powerPreviouslyConnected") {
            questionItem["powerAbolished"] = -1;
        } else if (e.target.name === "pitOnSite") {
            questionItem["pitDistanceId"] = -1;
            questionItem["superSafeDiggingTrench"] = -1;
        }

        props.updatePowerPoleQuestions(questions, false);
    }

    const handleQuestionPriceChange = (e: any) => {
        var questions = props.powerPoleQuestions;
        let questionItem: any = {};
        questionItem = questions;
        questionItem[e.target.name] = e.target.value * 1;

        if (e.target.name === "superSafeConnecting") {
            //reset supplier id if they change the connecting option
            questionItem["superSafeSupplierId"] = -1;
        }

        props.updatePowerPoleQuestions(questions, true);
    }

    const handleGateCodeChange = (e: any) => {
        props.updateGateCode(e.target.value);
    }

    return (
        <div>
            <label className="input-group" htmlFor="superSafeConnecting">
                <span className="label label-large">Is Super Safe connecting the electricity?</span>
                <select className="select" id="superSafeConnecting" name="superSafeConnecting" value={props.powerPoleQuestions.superSafeConnecting} onChange={(e) => handleQuestionPriceChange(e)} disabled={props.isReadOnly}>
                    <option hidden defaultValue="-1"></option>
                    {props.yesNoOptions.map(yn =>
                        <option key={yn.id} value={yn.id}>{yn.name}</option>
                    )};
                </select>
            </label>
            <span className={props.errors["superSafeConnecting"] ? "label errors" : "hidden"}>{props.errors["superSafeConnecting"]}</span>

            <label className={props.powerPoleQuestions.superSafeConnecting === 1 ? "input-group" : "hidden"} htmlFor="superSafeSupplierId">
                <span className="label label-large">Select Super Safe Distributor</span>
                <select className="select" id="superSafeSupplierId" name="superSafeSupplierId" value={props.powerPoleQuestions.superSafeSupplierId} onChange={(e) => handleQuestionPriceChange(e)} disabled={props.isReadOnly}>
                    <option hidden defaultValue="-1"></option>
                    {props.superSafeSupplierOptions.map(sup =>
                        <option key={sup.id} value={sup.id}>{sup.name}</option>
                    )};
                </select>
            </label>
            <span className={props.errors["superSafeSupplierId"] ? "label errors" : "hidden"}>{props.errors["superSafeSupplierId"]}</span>

            <label className="input-group" htmlFor="powerPoleLocationId">
                <span className="label label-large">Where is the power pole to be placed?</span>
                <select className="select" id="powerPoleLocationId" name="powerPoleLocationId" value={props.powerPoleQuestions.powerPoleLocationId} onChange={(e) => handleQuestionChange(e)} disabled={props.isReadOnly}>
                    <option hidden defaultValue="-1"></option>
                    {props.powerPoleLocationOptions.map(loc =>
                        <option key={loc.id} value={loc.id}>{loc.name}</option>
                    )};
                </select>
            </label>
            <span className={props.errors["powerPoleLocationId"] ? "label errors" : "hidden"}>{props.errors["powerPoleLocationId"]}</span>

            <label className="input-group" htmlFor="powerPreviouslyConnected">
                <span className="label label-large">Is there or has there ever been power connected to the property?</span>
                <select className="select" id="powerPreviouslyConnected" name="powerPreviouslyConnected" value={props.powerPoleQuestions.powerPreviouslyConnected} onChange={(e) => handleQuestionChange(e)} disabled={props.isReadOnly}>
                    <option hidden defaultValue="-1"></option>
                    {props.yesNoOptions.map(yn =>
                        <option key={yn.id} value={yn.id}>{yn.name}</option>
                    )};
                </select>
            </label>
            <span className={props.errors["powerPreviouslyConnected"] ? "label errors" : "hidden"}>{props.errors["powerPreviouslyConnected"]}</span>

            <label className={props.powerPoleQuestions.powerPreviouslyConnected === 1 ? "input-group" : "hidden"} htmlFor="powerAbolished">
                <span className="label label-large">Has the power been abolished?</span>
                <select className="select" id="powerAbolished" name="powerAbolished" value={props.powerPoleQuestions.powerAbolished} onChange={(e) => handleQuestionChange(e)} disabled={props.isReadOnly}>
                    <option hidden defaultValue="-1"></option>
                    {props.yesNoOptions.map(yn =>
                        <option key={yn.id} value={yn.id}>{yn.name}</option>
                    )};
                </select>
            </label>
            <span className={props.errors["powerAbolished"] ? "label errors" : "hidden"}>{props.errors["powerAbolished"]}</span>

            <div className={props.powerPoleQuestions.powerPreviouslyConnected === 1 && props.powerPoleQuestions.powerAbolished === 0 ? "" : "hidden"}>
                <div className="errors">Customer must organise the power to be abolished before we can organise the job</div>
                <div className="errors">Note: You can still save the job, but it won't be sent to Logistics until customer has organised power to be abolished.</div>
            </div>

            <label className="input-group" htmlFor="siteLocked">
                <span className="label label-large">Is the site locked?</span>
                <select className="select" id="siteLocked" name="siteLocked" value={props.powerPoleQuestions.siteLocked} onChange={(e) => handleQuestionChange(e)} disabled={props.isReadOnly}>
                    <option hidden defaultValue="-1"></option>
                    {props.yesNoOptions.map(yn =>
                        <option key={yn.id} value={yn.id}>{yn.name}</option>
                    )};
                </select>
            </label>
            <span className={props.errors["siteLocked"] ? "label errors" : "hidden"}>{props.errors["siteLocked"]}</span>

            <div className={props.powerPoleQuestions.siteLocked === 1 ? "" : "hidden"}>
                <label className="input-group" htmlFor="gatecode">
                    <span className="label label-large">Gate Code</span>
                    <input className="input" type="text" maxLength={20} id="gatecode" name="gateCode" value={props.gateCode} onChange={(e) => handleGateCodeChange(e)} disabled={props.isReadOnly}></input>
                </label>
            </div>

            <div className={props.isUnderground ? "hidden" : ""}>
                <label className="input-group" htmlFor="clearSightLine">
                    <span className="label label-large">Is there a clear line of site to the street pole from the temp power pole location (i.e. no trees in the way)?</span>
                    <select className="select" id="clearSightLine" name="clearSightLine" value={props.powerPoleQuestions.clearSightLine} onChange={(e) => handleQuestionChange(e)} disabled={props.isReadOnly}>
                        <option hidden defaultValue="-1"></option>
                        {props.yesNoOptions.map(yn =>
                            <option key={yn.id} value={yn.id}>{yn.name}</option>
                        )};
                    </select>
                </label>
                <span className={props.errors["clearSightLine"] ? "label errors" : "hidden"}>{props.errors["clearSightLine"]}</span>

                <div className={props.powerPoleQuestions.clearSightLine === 0 ? "" : "hidden"}>
                    <div className="errors">Check the following with the customer:</div>
                    <div className="errors">Note: if waiting for customer to get trees trimmed, you can still save the job but it won't go to logistics until there is a clear line of sight.</div>
                    <div className="">Can the pole be moved to another location with a clear line of site to a street pole?</div>
                    <div className="">Can the customer orgaise with the council to get the trees trimmed</div>
                    <div className="">Do we need to do a Site Visit?</div>
                </div>
            </div>

            <div className={props.isUnderground ? "" : "hidden"}>
                <label className="input-group" htmlFor="pitOnSite">
                    <span className="label label-large">Is there a pit onsite?</span>
                    <select className="select" id="pitOnSite" name="pitOnSite" value={props.powerPoleQuestions.pitOnSite} onChange={(e) => handleQuestionChange(e)} disabled={props.isReadOnly}>
                        <option hidden defaultValue="-1"></option>
                        {props.yesNoOptions.map(yn =>
                            <option key={yn.id} value={yn.id}>{yn.name}</option>
                        )};
                    </select>
                </label>
                <span className={props.errors["pitOnSite"] ? "label errors" : "hidden"}>{props.errors["pitOnSite"]}</span>

                <div className={props.powerPoleQuestions.pitOnSite === 0 ? "" : "hidden"}>
                    <div className="errors">Need to change to an Above Ground pole or customer to apply to the appropriate distributor to get a pit installed.</div>
                    <div className="errors">Note: if waiting for customer to apply for a pit, you can still save the job but it won't go to logistics until customer has organised pit.</div>
                </div>

                <div className={props.powerPoleQuestions.pitOnSite === 1 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="pitDistanceId">
                        <span className="label label-large">How many meters is there between the pit and the location of the temporary power pole?</span>
                        <select className="select" id="pitDistanceId" name="pitDistanceId" value={props.powerPoleQuestions.pitDistanceId} onChange={(e) => handleQuestionPriceChange(e)} disabled={props.isReadOnly}>
                            <option hidden defaultValue="-1"></option>
                            {props.powerPoleDistanceOptions.map(dis =>
                                <option key={dis.id} value={dis.id}>{dis.name}</option>
                            )};
                        </select>
                    </label>
                    <span className={props.errors["pitDistanceId"] ? "label errors" : "hidden"}>{props.errors["pitDistanceId"]}</span>

                    <label className="input-group" htmlFor="superSafeDiggingTrench">
                        <span className="label label-large">Is Super Safe digging the trench? Note: there is an extra charge for Super Safe to dig the trench.</span>
                        <select className="select" id="superSafeDiggingTrench" name="superSafeDiggingTrench" value={props.powerPoleQuestions.superSafeDiggingTrench} onChange={(e) => handleQuestionPriceChange(e)} disabled={props.isReadOnly}>
                            <option hidden defaultValue="-1"></option>
                            {props.yesNoOptions.map(yn =>
                                <option key={yn.id} value={yn.id}>{yn.name}</option>
                            )};
                        </select>
                    </label>
                    <span className={props.errors["superSafeDiggingTrench"] ? "label errors" : "hidden"}>{props.errors["superSafeDiggingTrench"]}</span>
                </div>
            </div>
        </div>
    )

}

export default NewJobPricelistPowerPoleQuestionsData;